<template>
    <path d="M19 13H5v-2h14v2z"/>
</template>

<script>
    export default {
        name: 'minus',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Minus.vue